module.exports = __webpack_public_path__ + "img/Dining-Filled.b07b767d.svg";